export type FormState = {
  reasonId: string
  customReason: string
  notServicedReason: string
  selectedServiceIds: string[]
  cancelConfirmation: string
}

export type NormalizedFormState = {
  reasonId: number
  customReason: string
  notServicedReason?: string
  selectedServiceIds: string[]
}

export const initialValues: FormState = {
  reasonId: '',
  customReason: '',
  notServicedReason: '',
  selectedServiceIds: [],
  cancelConfirmation: '',
}

export function normalize(model: FormState): NormalizedFormState {
  const { reasonId, customReason, notServicedReason, selectedServiceIds } =
    model

  return {
    customReason,
    reasonId: reasonId === 'custom' ? 0 : Number(reasonId),
    notServicedReason:
      notServicedReason.trim() === '' ? undefined : notServicedReason,
    selectedServiceIds,
  }
}
